// extracted by mini-css-extract-plugin
export default {"sectionParameterTitle":"SectionParameter_sectionParameterTitle__j2gv3","sectionParameterValue":"SectionParameter_sectionParameterValue__L5Bhl"};